import { render, staticRenderFns } from "./bossview.vue?vue&type=template&id=5d7238dc&scoped=true&"
import script from "./bossview.vue?vue&type=script&lang=js&"
export * from "./bossview.vue?vue&type=script&lang=js&"
import style0 from "./bossview.vue?vue&type=style&index=0&id=5d7238dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7238dc",
  null
  
)

export default component.exports